import {MessageDisplayStrategy} from "@app/core/user-marketing-rules/application/message-display-strategy";
import {Injectable} from "@angular/core";

/**
 * Strategy used when the application is compiled as a mobile app.
 * Determines whether messages (e.g., "Download App") can be shown in this context.
 */
@Injectable()
export class AppMessageDisplayStrategy implements MessageDisplayStrategy {
    canDisplayDownloadAppMessage(): boolean {
        return false;
    }
}